"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore next */
var fetchStates = function (countryCode, locale) {
    return new Promise(function (resolve, reject) {
        var HOST = 'https://cashier-services.wix.com/cashier-metadata';
        var xhr = new window.XMLHttpRequest();
        xhr.open('GET', HOST + "/api/v2/locales/states?countryCode=" + countryCode + "&locale=" + locale, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 400) {
                try {
                    var response = JSON.parse(xhr.responseText);
                    resolve(response.states || []);
                }
                catch (e) {
                    reject(e);
                }
            }
            else if (xhr.readyState === 4 && xhr.status !== 200) {
                reject(new Error('Bad server status'));
            }
        };
        xhr.send();
    });
};
exports.default = {
    fetchStates: fetchStates,
};
//# sourceMappingURL=stateApiService.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Fields/StateAutoComplete/stateApiService.js
// module id = 202
// module chunks = 0 1